import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Toggle from 'react-toggle';
import Label from '../../components/foundations/Label';
import { MEMBER_TYPES, translationPrefix as translationRootPrefix } from '../utils';
import 'react-toggle/style.css';
import css from './AddFutureItems.css';

const translationPrefix = `${translationRootPrefix}.AUTO_ADD_FUTURE_ITEMS`;
const TITLE_TRANSLATION_KEYS = {
    [MEMBER_TYPES.AGENCY]: {
        appsite: 'APPSITES_AGENCIES',
    },
};
const DESCRIPTION_TRANSLATION_KEYS = {
    [MEMBER_TYPES.AGENCY]: {
        appsite: 'APPSITES_AGENCIES',
        partner: 'PARTNERS_AGENCIES',
    },
};

const AddFutureItems = ({
    activeMemberType = '',
    itemType = '',
    addFuture = false,
    onChange = () => {},
    className = '',
}) => {
    const descriptionTranslationKey = DESCRIPTION_TRANSLATION_KEYS[activeMemberType]?.[itemType];
    const titleTranslationKey = TITLE_TRANSLATION_KEYS[activeMemberType]?.[itemType] || 'GENERAL';

    return (
        <div className={classNames(css.container, className)}>
            <Toggle
                icons={false}
                checked={addFuture}
                onChange={e => onChange(e.target.checked)}
                className={css.toggle}
            />
            <div className={css.labelContainer}>
                <Label
                    type="sideLabel"
                    className={css.title}
                    text={`${translationPrefix}.TITLE.${titleTranslationKey}`}
                    textReplace={{
                        itemType,
                    }}
                />
                {descriptionTranslationKey && (
                    <Label type="p" text={`${translationPrefix}.DESCRIPTION.${descriptionTranslationKey}`} />
                )}
            </div>
        </div>
    );
};

AddFutureItems.propTypes = {
    activeMemberType: PropTypes.string,
    itemType: PropTypes.string,
    addFuture: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

export default AddFutureItems;
